import axios from 'axios';
import { buildApiUrl } from '../config/api'; // ajusta la ruta si es necesario

export const AuthService = {
    login: async ({ documento, password }) => {
        try {
            const url = buildApiUrl('/api/auth/login');
            const response = await axios.post(url, {
                documento,
                password,
                origin: 'web',
            });

            return response.data;
        } catch (error) {
            console.error('Error en AuthService.login:', error);
            throw error;
        }
    },
    recoverPassword: async (documentNumber) => {
        try {
            const url = buildApiUrl('/api/auth/recover-password');
            const response = await axios.post(url, { documentNumber });
            return response.data; // contiene success y message
        } catch (error) {
            console.error('Error en AuthService.recoverPassword:', error);
            throw error;
        }
    },
};
